import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}



export default {
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    department() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/crew/department");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    position() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/crew/position");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    group() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/crew/group");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`salarydeal/${obj.crewkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detaildeal(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`salarydeal/detail/${obj.contractkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    projectpaketgaji(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`projectpaketgaji/detail/${obj.pangkatid}/${obj.projectid}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'compcode', 'crewnik', 'crewname', 'jabatan', 'departemen', 'pangkat', 'golongan', 'managerInfo', 'terminate', 'officer', 'projectid', 'projectname'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                const url = `/salarydeal${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportxls(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'crewnik', 'crewname', 'jabatan', 'departemen', 'pangkat', 'golongan', 'managerInfo', 'terminate', 'projectid', 'projectname'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                let response = await axios({
                    url: `/salarydeal/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `salary_agreement_List.xlsx`);
                document.body.appendChild(link);
                link.click();
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/salarydeal/${obj.crewkey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    save(data) {
        return new Promise(async (resolve, reject) => {
            try {
                // delete data.materials;
                const resp = await axios.post('/salarydeal', data);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    taxgroup() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/crew/taxgroup`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    }
};